<template>
  <div class="overlap-group-wrapper-subsection">
    <div class="overlap-group-2">
      <div class="rectangle-wrapper">
        <div class="rectangle" />
      </div>

      <div class="text-wrapper-9">广东朗乾律师事务所</div>

      <div class="text-wrapper-10">
        无私天地宽，专业的法律团队，专注解决法律问题
      </div>

      <p class="langqian-law-firm-a">
        Langqian Law Firm
        <br />A professional legal team focused on solving legal issues
      </p>

      <img class="line" alt="Line" src="/img/line-1.svg" />

      <div class="rectangle-2" />

      <div class="text-wrapper-11"  @click="navigateToAboutUs">了解更多</div>


    </div>
  </div>
</template>

<script>
import router from '../../../../router';

export default {
  name: "Header",
  data() {
  	return{
		 hoverIndex: -1,       // 当前悬停项
		      lastHoverIndex: 0     // 最近一次悬停项，默认首页高亮
	}
  },
  methods: {
	 handleMouseOver(index) {
	      this.hoverIndex = index;
	      this.lastHoverIndex = index;
	    },
	    handleMouseLeave() {
	      this.hoverIndex = -1;
	    },
		getHoverClass(index) {
		      return (this.hoverIndex === index || (this.hoverIndex === -1 && this.lastHoverIndex === index))
		        ? 'hover_ment' : '';
		    },
	
    navigateToAboutUs() {
      router.push({
		  path: '/about'
	  })
    },
    navigateToNewsUpdates() {
      this.$emit('navigate', 'news-updates')
    },
    navigateToPartyBuilding() {
      this.$emit('navigate', 'party-building')
    },
    navigateToContactUs() {
      this.$emit('navigate', 'contact-us')
    },
    navigateToJoinUs() {
      this.$emit('navigate', 'join-us')
    },
    navigateToTeamSpotlight() {
      this.$emit('navigate', 'team-spotlight')
    }
  }
};
</script>

<style scoped>
	.hover_ment{
		/* background-color: red; */
		
		padding-bottom: 10px !important;
		border-bottom: 3px solid #ffffff !important;
	}
.overlap-group-wrapper-subsection {
  height: 651px;
  left: 0;
  /* position: absolute; */
  top: 0;
  width: 1208px;
}

.overlap-group-wrapper-subsection .logo {
  height: 32px;
  left: 0;
  position: absolute;
  top: 12px;
  width: 136px;
}

.overlap-group-wrapper-subsection .overlap-group-2 {
  height: 651px;
  position: relative;
  width: 1208px;
}

.overlap-group-wrapper-subsection .rectangle-wrapper {
  background-image: url(/img/rectangle-10.png);
  background-position: 50% 50%;
  background-size: cover;
  height: 651px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1208px;
}

.overlap-group-wrapper-subsection .rectangle {
  background-color: #380c0c4c;
  height: 651px;
}

.overlap-group-wrapper-subsection .text-wrapper-9 {
  color: #ffffff;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 42px;
  font-weight: 400;
  left: 74px;
  letter-spacing: 11.34px;
  line-height: normal;
  position: absolute;
  top: 121px;
}

.overlap-group-wrapper-subsection .text-wrapper-10 {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 74px;
  letter-spacing: 2.64px;
  line-height: normal;
  position: absolute;
  top: 207px;
}

.overlap-group-wrapper-subsection .langqian-law-firm-a {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 20px;
  font-weight: 500;
  left: 75px;
  letter-spacing: 0.60px;
  line-height: normal;
  position: absolute;
  top: 271px;
}

.overlap-group-wrapper-subsection .line {
  height: 1px;
  left: 75px;
  object-fit: cover;
  position: absolute;
  top: 190px;
  width: 199px;
}

.overlap-group-wrapper-subsection .rectangle-2 {
  background-color: #7a3529;
  height: 40px;
  left: 74px;
  position: absolute;
  top: 397px;
  width: 120px;
}

.overlap-group-wrapper-subsection .text-wrapper-11 {
  color: #ffffff;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 94px;
  letter-spacing: 2.70px;
  line-height: normal;
  position: absolute;
  top: 404px;
  cursor: pointer;
}

.overlap-group-wrapper-subsection .navbar {
  height: 40px;
  left: 295px;
  position: absolute;
  top: 0;
  width: 702px;
}

.overlap-group-wrapper-subsection .rectangle-3 {
  background-color: #ffffff;
  height: 4px;
  left: 2px;
  position: absolute;
  top: 0;
  width: 24px;
}

.overlap-group-wrapper-subsection .text-wrapper-12 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 20px;
}

.overlap-group-wrapper-subsection .text-wrapper-13 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  left: 82px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 20px;
}

.overlap-group-wrapper-subsection .text-wrapper-14 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  left: 522px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 20px;
}

.overlap-group-wrapper-subsection .text-wrapper-15 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  left: 192px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 20px;
}

.overlap-group-wrapper-subsection .text-wrapper-16 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  left: 302px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 20px;
}

.overlap-group-wrapper-subsection .text-wrapper-17 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  left: 412px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 20px;
}

.overlap-group-wrapper-subsection .text-wrapper-18 {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  font-weight: 500;
  /* left: 632px; */
  letter-spacing: 0;
  line-height: normal;
  /* position: absolute; */
  /* top: 20px; */
}
</style>